'use client';

import { createContext, useContext, useMemo, useState, type PropsWithChildren } from 'react';

/**
 * Holds whatever domain the visitor has typed into a scan field, so the "Get a demo" CTAs can
 * report which brand the demand came from. Those CTAs sit in the header and footer, nowhere near
 * the field, so passing it down as a prop isn't an option.
 */
const ScanDomainContext = createContext<{
  domain: string;
  setDomain: (domain: string) => void;
} | null>(null);

export function ScanDomainProvider({ children }: PropsWithChildren) {
  const [domain, setDomain] = useState('');
  const value = useMemo(() => ({ domain, setDomain }), [domain]);
  return <ScanDomainContext.Provider value={value}>{children}</ScanDomainContext.Provider>;
}

export function useScanDomain() {
  const context = useContext(ScanDomainContext);
  if (!context) throw new Error('useScanDomain must be used inside ScanDomainProvider');
  return context;
}

/** For CTAs that only read the domain: usable outside the provider, where it reports nothing. */
export function useTypedDomain(): string {
  return useContext(ScanDomainContext)?.domain ?? '';
}
